import gql from 'graphql-tag'
import { Course } from '~/graphql/fragments/course.js'
import { User } from '~/graphql/fragments/user.js'
export const GET__ACADEMY_COURSES_BY_TYPE = gql`
  query academyCourses(
    $type: CourseType
    $tags: [String]
    $limit: Int
    $search: String
    $status: CourseStatus
    $top: Int
    $page: Int
    $schoolId: Int
    $isLatest: Boolean
    $noUpdatedDraft: Boolean
    $onlyShowEnrolledVersion: Boolean
    $sharedCourseEnrollable: Boolean
    $includeSharedCourseMode: SharedCourseMode
  ) {
    academyCourses(
      type: $type
      tags: $tags
      limit: $limit
      search: $search
      status: $status
      top: $top
      page: $page
      schoolId: $schoolId
      isLatest: $isLatest
      noUpdatedDraft: $noUpdatedDraft
      onlyShowEnrolledVersion: $onlyShowEnrolledVersion
      sharedCourseEnrollable: $sharedCourseEnrollable
      includeSharedCourseMode: $includeSharedCourseMode
    ) {
      data {
        status
        id
        name
        desc
        slug
        cover
        schoolId
        popular
        published
        courseUserRatings {
          userId
          id
          updatedAt
          rating
          user {
            name: fullName
            media {
              url
            }
          }
        }
        rating
        inMyList
        courseVersionIds
        updateStatus
        duration
        trainer {
          id
          name
        }
        totalTime
        learnMode
        courseMedias {
          id
          media {
            thumbnail
            id
          }
        }
        topics {
          id
          mediaFromTime
          mediaToTime
        }
        schedule {
          lessonDuration
        }
        venue {
          location
          address_1
        }
        scheduleClasses {
          startDatetime
          endDatetime
        }
      }
      meta {
        limit
        page
        total
      }
    }
  }
`
export const GET_ACADEMY_COURSE_INFO = gql`
  query academyCourse($slug: String!) {
    academyCourse(slug: $slug) {
      ...Course
    }
  }
  ${Course}
`

export const GET_ALL_COURSES = gql`
  query academySchoolCourses($schoolId: Int!, $limit: Int, $page: Int, $search: String, $haveActivities: Boolean) {
    academySchoolCourses(
      schoolId: $schoolId
      page: $page
      limit: $limit
      search: $search
      haveActivities: $haveActivities
    ) {
      data {
        id
        userId
        name
        desc
        slug
        cover
        objectives
        published
        publishedAt
        trainer {
          id
          name
          media {
            id
            url
          }
        }
        likedCount
        viewedCount
        enrolledCount
        courseMedias {
          id
          media {
            thumbnail
            source
            url
            fileName
            id
            status
          }
          transcript
        }
        topics {
          id
          name
          order
          content {
            questions {
              id
              options {
                id
                right
                title
              }
              title
            }
          }
          topicType
          mediaFromTime
          mediaToTime
          media {
            thumbnail
            source
            url
            scormMediaId
          }
        }
        insertedAt
      }
      meta {
        total
        limit
        page
      }
    }
  }
`

export const MY_COURSES = gql`
  query academyMyCourseEnroll(
    $limit: Int
    $page: Int
    $search: String
    $sortDirection: SortDirection
    $sortField: CourseEnrollAllowedSortField
    $activityStatus: MyCourseEnrollStatus
    $forMyActivityPage: Boolean
  ) {
    academyMyCourseEnroll(
      limit: $limit
      page: $page
      search: $search
      sortDirection: $sortDirection
      sortField: $sortField
      activityStatus: $activityStatus
      forMyActivityPage: $forMyActivityPage
    ) {
      data {
        id
        endDate
        startDate
        insertedAt
        status
        updatedAt
        completedAt
        verifyStatus
        approvalId
        isAssigned
        topicEnrolls {
          currentTime
          score
          status
        }
        verifyReason
        verifyIsCompleted
        answers {
          id
        }
        user {
          id
        }
        courseId
        course {
          id
          name
          type
          duration
          slug
          learnMode
          schoolId
          cover
          updatedAt
          insertedAt
          courseVersionIds
          updateStatus
          topics {
            mediaFromTime
            mediaToTime
          }
          questions {
            id
          }
        }
      }
      meta {
        limit
        page
        total
      }
    }
  }
`
export const GET_INTERNAL_COURSES = gql`
  query academyCourses(
    $tags: [String]
    $limit: Int
    $page: Int
    $search: String
    $top: Int
    $schoolId: Int
    $statuses: [CourseStatus]
    $isLatest: Boolean
    $noUpdatedDraft: Boolean
    $onlyShowEnrolledVersion: Boolean
    $includeSharedCourseMode: SharedCourseMode
    $sharedCourseEnrollable: Boolean
    $sharedCourseOptions: [CourseSharingOption]
  ) {
    academyCourses(
      type: INTERNAL
      tags: $tags
      limit: $limit
      page: $page
      search: $search
      top: $top
      schoolId: $schoolId
      statuses: $statuses
      isLatest: $isLatest
      noUpdatedDraft: $noUpdatedDraft
      onlyShowEnrolledVersion: $onlyShowEnrolledVersion
      includeSharedCourseMode: $includeSharedCourseMode
      sharedCourseEnrollable: $sharedCourseEnrollable
      sharedCourseOptions: $sharedCourseOptions
    ) {
      data {
        name
        id
        slug
        type
        setting {
          language
          minCapacity
          maxCapacity
        }
        insertedAt
        updatedAt
        status
        courseSchoolPermissions {
          schoolId
          school {
            type
          }
          enrollable
          sharingOption
        }
        learnMode
        duration
        topics {
          id
          mediaFromTime
          mediaToTime
        }
        courseVersionIds
        updateStatus
        scheduleClasses {
          id
          name
          startDatetime
          status
          endDatetime
          videoLink
          full
          enrolledCount
          enrolledUsers {
            ...User
          }
          trainers {
            name
          }
          regularPeriod {
            schedule
          }
          scheduleLessons {
            name
            startDatetime
            endDatetime
            rescheduled
            trainers {
              name
            }
            trainersLessons {
              trainer {
                name
              }
              replaced
            }
          }
        }
      }
      meta {
        total
        limit
        page
      }
    }
  }
  ${User}
`

export const GET_LIST_COURSE = gql`
  query academyCourses(
    $tags: [String]
    $limit: Int
    $page: Int
    $search: String
    $top: Int
    $schoolId: Int
    $type: CourseType
    $status: CourseStatus
    $learnMode: CourseLearnMode
    $isLatest: Boolean
    $noUpdatedDraft: Boolean
    $onlyShowEnrolledVersion: Boolean
    $includeSharedCourseMode: SharedCourseMode
    $sharedCourseOptions: [CourseSharingOption]
  ) {
    academyCourses(
      type: $type
      tags: $tags
      limit: $limit
      page: $page
      search: $search
      top: $top
      schoolId: $schoolId
      status: $status
      learnMode: $learnMode
      isLatest: $isLatest
      noUpdatedDraft: $noUpdatedDraft
      onlyShowEnrolledVersion: $onlyShowEnrolledVersion
      includeSharedCourseMode: $includeSharedCourseMode
      sharedCourseOptions: $sharedCourseOptions
    ) {
      data {
        name
        id
        slug
        type
        published
        setting {
          language
          minCapacity
          maxCapacity
        }
        insertedAt
        updatedAt
        status
        learnMode
        duration
        courseVersionIds
        topics {
          id
          mediaFromTime
          mediaToTime
        }
        scheduleClasses {
          id
          name
          startDatetime
          status
          endDatetime
          videoLink
          full
          enrolledCount
          enrolledUsers {
            ...User
          }
          trainers {
            name
          }
          regularPeriod {
            schedule
          }
          scheduleLessons {
            name
            startDatetime
            endDatetime
            rescheduled
            trainers {
              name
            }
            trainersLessons {
              trainer {
                name
              }
              replaced
            }
          }
        }
      }
      meta {
        total
        limit
        page
      }
    }
  }
  ${User}
`

export const StaffListItem = gql`
  fragment StaffListItem on User {
    id
    fullName
    media {
      url
    }
    personalProfiles {
      id
      name
      designation
      media {
        url
      }
      school {
        id
      }
    }
  }
`

export const GET_STAFF_ENROL_REQUESTS_SUMMARY = gql`
  query academyStaffCourseEnrollSummary($mode: CourseEnrollMode, $schoolIds: [Int], $upcomingStartDays: Int) {
    academyStaffCourseEnrollSummary(mode: $mode, schoolIds: $schoolIds, upcomingStartDays: $upcomingStartDays) {
      staffList {
        ...StaffListItem
      }
      pendingApproval {
        staffList {
          ...StaffListItem
        }
        total
      }
      postCourseReview {
        staffList {
          ...StaffListItem
        }
        total
      }
      upcomingTraining {
        staffList {
          ...StaffListItem
        }
        total
      }
    }
  }
  ${StaffListItem}
`
export const GET_STAFF_ENROL_REQUESTS = gql`
  query academyStaffCourseEnroll(
    $enrollIds: [Int]
    $limit: Int
    $page: Int
    $courseTypes: [CourseType]
    $forDetailPage: Boolean! = false
    $review: String
    $schoolIds: [Int]
    $upcomingStartDays: Int
    $status: CourseEnrollStatus
    $userId: Int
    $search: String
    $mode: CourseEnrollMode
  ) {
    academyStaffCourseEnroll(
      enrollIds: $enrollIds
      limit: $limit
      page: $page
      courseTypes: $courseTypes
      review: $review
      schoolIds: $schoolIds
      upcomingStartDays: $upcomingStartDays
      status: $status
      userId: $userId
      search: $search
      mode: $mode
    ) {
      data {
        id
        status
        insertedAt
        updatedAt
        verifyIsCompleted
        verifyReason
        verifyRequestedAt
        verifyStatus
        startDate
        endDate
        approval @include(if: $forDetailPage) {
          ...User
        }
        answers {
          answerBy
          content
          insertedAt
          updatedAt
          id
          questionId
          reviewer {
            ...User
          }
        }
        course {
          ...Course
        }
        applicantInfo {
          otherCount
          status
          applicants {
            ...User
          }
        }
        user {
          ...User
        }
        replacementStaff {
          ...User
        }
      }
      meta {
        total
        limit
        page
      }
    }
  }
  ${Course}
  ${User}
`

export const GET_COURSE_ENROLL_DETAIL = gql`
  query academyCourseEnrollDetail($enrollId: Int!) {
    academyCourseEnrollDetail(enrollId: $enrollId) {
      id
      status
      insertedAt
      verifyIsCompleted
      verifyReason
      verifyRequestedAt
      verifyStatus
      startDate
      endDate
      class {
        videoLink
      }
      approval {
        ...User
      }
      approveNotes
      rejectNotes
      rejectReason
      answers {
        answerBy
        content
        insertedAt
        updatedAt
        id
        questionId
        reviewer {
          ...User
        }
      }
      course {
        ...Course
        trainer {
          id
          name
          desc
          media {
            url
          }
        }
      }
      applicantInfo {
        otherCount
        status
        applicants {
          ...User
        }
      }
      user {
        ...User
      }
      replacementStaff {
        ...User
      }
      verifyUser {
        fullName
      }
    }
  }
  ${Course}
  ${User}
`
export const GET_COURSE_AUDIT_LOG = gql`
  query userActivityHistories($courseId: Int, $limit: Int, $page: Int) {
    userActivityHistories(courseId: $courseId, limit: $limit, page: $page) {
      data {
        action
        updatedAt
        changes
        user {
          ...User
        }
      }
      meta {
        total
        limit
        page
      }
    }
  }
  ${User}
`

export const GET_POST_COURSE_REVIEW_COUNT = gql`
  query academyPostCourseNeedReviewCount($schoolId: Int!) {
    academyPostCourseNeedReviewCount(schoolId: $schoolId) {
      value
    }
  }
`

export const ACADEMY_SCORM_MEDIA = gql`
  query academyScormMedia($id: String!) {
    academyScormMedia(id: $id) {
      id
      title
      description
      mainIndexPath
      metadata
      thumbnail
      courseDuration
      learningTime
      media {
        id
        url
        status
        thumbnail
      }
    }
  }
`

export const ACADEMY_SCORM_PROGRESS = gql`
  query academyScormProgress($schoolId: Int!, $scormMediaId: String!) {
    academyScormProgress(schoolId: $schoolId, scormMediaId: $scormMediaId) {
      id
      userId
      schoolId
      topicId
      courseId
      scormMediaId
      scormMetadata
      insertedAt
      updatedAt
    }
  }
`
